var modules_31ab199a = {"tabPane":"_4507e7","accordion-item":"_1j5uek","menu":"_11eapfz","menu__badge":"_1fvyq52","menu__item":"_1huoh9","dialog":"_116yg0l"};
import "../../../../../assets/B-XZpKC_.css";

export { modules_31ab199a as default };
//# sourceMappingURL=Headings.module.scss.js.map
